import { Injectable } from '@angular/core';
import * as ApiProduct from '../../interfaces/api/product';
import { MHProduct } from '../../interfaces/product';

@Injectable({
  providedIn: 'root',
})
export class ProductTransformer {
  transform(data: ApiProduct.MHProduct): MHProduct {
    return {
      id: data.id,
      reff_id: data.reff_id,
      reff_type: data.reff_type,
      id_from_import: data.id_from_import,
      name: data.name,
      main_code: data.main_code,
      price: data.price,
      base_discount: data.base_discount,
      sold: data.sold,
      images: data.images,
      description: data.description,
      dimension: data.dimension,
      weight: data.weight,
      bitly_url: data.bitly_url,
      is_active: data.is_active,
      is_preorder: data.is_preorder,
      is_show_on_first_page: data.is_show_on_first_page,
      created_by: data.created_by,
      updated_by: data.updated_by,
      image_url: data.image_url,
      fake_price: data.fake_price,
      stock: data.stock,
      price_after_discount: data.price_after_discount,
      detail: data.detail,
      md_stock: data.md_stock,
      mh_sub_category: data.mh_sub_category,
      MhTag: data.MhTag,
      is_wishlisted: data.is_wishlisted,
      MdProductGallery: data.MdProductGallery,
    };
  }
}
